import { useFormikContext } from 'formik';
import { find } from 'lodash';
import React from 'react';
import { useIntl } from 'react-intl';
import { StoreContext } from 'utils/contextStore';
import ComplementInputs from './complementInputs';
import FoldersList from './FoldersList';
import {
  concernedPeopleMapping,
  documentFilesMapping,
  foldersTypeListMapping,
  mandatoryFilesListMapping,
  mappedOrganismeList,
} from './mapping';
import RecapFolderProcess from './RecapFolderProcess';
import UploadFiles from './uploadFiles';

const ActiveStep = ({ activeStep }: any) => {
  // STATES BEGIN
  const {
    organismeListState,
    mandatoryFilesState,
    foldersListState,
    concernedPeopleState,
    checkFirstDeclareState,
  } = React.useContext(StoreContext);
  const getOrganismeList = organismeListState?.organismeList;
  const mandatoryFiles = mandatoryFilesState?.mandatoryFiles;
  const foldersList = foldersListState?.foldersList;
  const concernedPeople = concernedPeopleState?.concernedPeople;
  const checkFirstDeclare = checkFirstDeclareState?.checkFirstDeclare;
  const intl = useIntl();
  const { values } = useFormikContext<any>();
  return (
    <>
      {(() => {
        switch (activeStep) {
          case 0:
            return values.organisme !== '' && checkFirstDeclare ? (
              <UploadFiles
                title={intl.formatMessage({
                  id: 'dmo.first.declaration.title',
                })}
                secondTitle={intl.formatMessage({
                  id: 'dmo.first.declaration.subtitle',
                })}
                items={mandatoryFilesListMapping(mandatoryFiles)}
                filesInputName="mandatoryFiles"
                filesLimit={2}
              />
            ) : (
              <>
                <FoldersList
                  FoldersListItems={mappedOrganismeList(getOrganismeList)}
                  titleCard={intl.formatMessage({
                    id: 'Home_text_Health_select_organisme',
                  })}
                  radioButtonName="organisme"
                />
              </>
            );
          case 1:
            return (
              <FoldersList
                FoldersListItems={foldersTypeListMapping(foldersList)}
                titleCard={intl.formatMessage({ id: 'dmo.select.type' })}
                activeSearch
                radioButtonName="typeDossier"
              />
            );
          case 2:
            return (
              <FoldersList
                FoldersListItems={concernedPeopleMapping(concernedPeople)}
                titleCard={intl.formatMessage({ id: 'dmo.select.pac' })}
                radioButtonName="concernedPeople"
              />
            );
          case 3: {
            const documents =
              values.typeDossier &&
              find(foldersList, { Code: values.typeDossier })['TypesSoins'];
            return (
              <UploadFiles
                title={intl.formatMessage({ id: 'dmo.join.files.title' })}
                items={documentFilesMapping(documents)}
                filesInputName="documentFiles"
                filesLimit={10}
              />
            );
          }

          case 4:
            return <ComplementInputs />;
          case 5:
            return <RecapFolderProcess />;
          default:
            return null;
        }
      })()}
    </>
  );
};
export default ActiveStep;
